import approaches from '../database/meta/approaches.json'
import types from '../database/meta/organization-types.json'

const renderMeta = (name, a) => {
  let found = undefined
  if(name === 'approach') found = approaches.find(d => d.id === a)
  if(name === 'type') found = types.find(d => d.id === a)
  if(found) return found.name
  return a
}

export { renderMeta }